import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-star",
  "use": "icon-icon-star-usage",
  "viewBox": "0 0 16.7 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16.7 16\" id=\"icon-icon-star\">\r\n<title>资源 6</title>\r\n<g id=\"icon-icon-star_图层_2_1_\">\r\n\t<g id=\"icon-icon-star_图层_1-2\">\r\n\t\t<g>\r\n\t\t\t<path d=\"M12.9,16c-0.1,0-0.3,0-0.4-0.1L8.4,14l-4.2,1.9c-0.3,0.1-0.7,0.1-1-0.1c-0.3-0.2-0.4-0.6-0.4-0.9l0.5-4.5L0.3,7\r\n\t\t\t\tC0,6.7-0.1,6.3,0,6c0.1-0.3,0.4-0.6,0.8-0.7l4.5-0.9l2.3-3.9C7.7,0.2,8,0,8.4,0c0.4,0,0.7,0.2,0.9,0.5l2.2,3.9l4.5,0.9\r\n\t\t\t\tc0.4,0.1,0.6,0.3,0.8,0.7c0.1,0.3,0,0.7-0.2,1l-3.1,3.4l0.5,4.5c0,0.4-0.1,0.7-0.4,0.9C13.3,15.9,13.1,16,12.9,16z M2.9,6.9\r\n\t\t\t\tl2.2,2.4c0.2,0.2,0.3,0.5,0.3,0.8L5,13.4L8,12c0.3-0.1,0.6-0.1,0.8,0l2.9,1.3l-0.4-3.2c0-0.3,0.1-0.6,0.3-0.8l2.2-2.4l-3.2-0.6\r\n\t\t\t\tC10.3,6.2,10.1,6,9.9,5.8L8.4,3L6.8,5.8C6.6,6,6.4,6.2,6.1,6.3L2.9,6.9z\" />\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-star.svg
// module id = xQx7
// module chunks = 71